exports = module.exports = require("../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".feedback-trigger-btn[data-v-b2497014]{font-size:11px;color:#ef4444;background:transparent;border:1px dashed #fca5a5;border-radius:4px;padding:2px 6px;cursor:pointer;-webkit-transition:all .15s ease;transition:all .15s ease}.feedback-trigger-btn[data-v-b2497014]:hover{background:#fee2e2}.feedback-textarea[data-v-b2497014]{width:100%;border:1px solid #cbd5e1;border-radius:4px;padding:6px;outline:none;background:#fff}.btn-cancel[data-v-b2497014]{background:#e2e8f0;color:#475569;border:none}", ""]);

// exports
